export const Storage_Keys = {
    "token": "token",
    "admin_data": "admin_data",
    "isFirstTime":"isFirstTime"
}
